"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ListIcon = _ref => {
  let {
    fill
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: fill
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M1 1.20532H14",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1 4.68555H14",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1 8.16565H14",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    strokeLinecap: "round"
  }));
};

ListIcon.propTypes = {
  fill: _propTypes.default.string.isRequired
};
var _default = ListIcon;
exports.default = _default;